export function postToIframe(message: unknown) {
  const iframe = document.querySelector("iframe") as HTMLIFrameElement;

  iframe.contentWindow?.postMessage(message, "*");
}
